module.exports = __webpack_public_path__ + "media/img/aztec-code-scan-7efa2a4c.svg";